import React from "react";
import { Route, Switch } from "react-router";
import { BuilderDataProvider } from "components/BuilderContext";
import { useDashboardState } from "components/DashboardContext";
import { useSelector } from "react-redux";

import WithUser from "screens/WithUser";
import Header from "components/Header";

const PrivateRoutes = () => {
  const { newUser } = useSelector((state) => state.user.info);
  const { signingState } = useDashboardState();

  return (
    <div className="dashboard">
      {(
        (signingState === null && !newUser)
        || signingState === 0 
        || signingState === 2) && (
          <Route 
            path="/"
            component={(props) => <Header {...props} />} 
          />
      )}

      <div className="dashboard-body">
        <BuilderDataProvider>
          <Switch>
            <Route path="/" component={WithUser} />
          </Switch>
        </BuilderDataProvider>
      </div>
    </div>
  );
};

export default PrivateRoutes;
